import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Stack, Typography } from '@mui/material';
import { Button, Header, NavHeader } from '../../../../../../components';
import { Page } from '../../../../../../components/page';
import { DashboardActionItem } from '../../components/dashboard-action-item/dashboard-action-item';
import { OverviewHeader } from '../../components/overview-header/overview-header';
import { OverviewText } from '../../components/overview-text/overview-text';
import { RoundedImage } from '../../components/rounded-image/rounded-image';

const TauronG13s: React.FC = () => {
  const { t } = useTranslation('dashboard');

  const renderNormalText = (text: string) => <OverviewText text={text} />;

  const renderHeaderText = (text: string, bold?: boolean) => <OverviewHeader text={text} bold={bold} />;

  return (
    <Page
      isStickyHeader
      containerClassName="page__container--flex-height p-t-0"
      header={
        <>
          <NavHeader />
          <Header title={t('tauronG13s.header')} isUnderline />
        </>
      }
    >
      <Box sx={{ maxWidth: '800px' }}>
        {renderNormalText(t('tauronG13s.description'))}
        {renderHeaderText(t('tauronG13s.howItWorks'))}
        {renderNormalText(t('tauronG13s.howItWorksDescription'))}
        <Stack spacing={2} direction="row" marginBottom={3}>
          <DashboardActionItem
            title={t('tauronG13s.hourlyZonesPerDay')}
            icon={<Typography sx={{ color: 'var(--color-accent)', fontSize: '24px' }}>24</Typography>}
          />
          <DashboardActionItem
            title={t('tauronG13s.hourlyZonesPerDay')}
            icon={<Typography sx={{ color: 'var(--color-accent)', fontSize: '24px' }}>96</Typography>}
          />
        </Stack>
        {renderHeaderText(t('tauronG13s.benefits'))}
        <RoundedImage url="images/g13s-1.png" />
        {renderHeaderText(t('tauronG13s.costPredictability'))}
        {renderNormalText(t('tauronG13s.costPredictabilityDescription'))}
        <RoundedImage url="images/g13s-2.png" />
        {renderHeaderText(t('tauronG13s.realImpactOnBills'))}
        {renderNormalText(t('tauronG13s.realImpactOnBillsDescription'))}
        {renderHeaderText(t('tauronG13s.potentialSavings'), true)}
        {renderHeaderText(t('tauronG13s.forWho'))}
        {renderNormalText(t('tauronG13s.forWhoDescription'))}
        <Button
          type="accent"
          center
          fullWidth
          onClick={() => window.open('https://www.tauron.pl/dla-domu/prad/prad-z-usluga/tanie-godziny', '_blank')}
        >
          {t('tauronG13s.goToOffer')}
        </Button>
      </Box>
    </Page>
  );
};

export default TauronG13s;
